import { Col as $Col } from 'antd';
import styled from 'styled-components';

export const MainLayoutColumn = styled($Col)``;
